<template>
    <v-flex xs12 sm6 md4 lg2 xl2 class="pa-2" >
        <v-card class="product-item-card" transition="scale-transition" @click="$emit('show-product-details', product)">
            <v-card-title class="d-block text-xs-center">
                <div>
                    <h3 class="title red--text font-weight-light">{{ product.brand }}</h3>
                    <span class="font-weight-light">{{ product.codeView }}</span>
                </div>
            </v-card-title>
            <v-card-text>
                <v-layout align-center >
                    <v-flex xs6>
                        <v-img style="margin-right: -1px" :src="`${publicPath}img/MRP-James-Bond.png`" :contain=true></v-img>
                    </v-flex>
                    <v-flex xs6 align-center class="product-color-box">
                        <v-responsive v-if="product.productsEffect === 'TRAS' && !product.rgb" aspect-ratio="1" style="background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAHklEQVQYlWMoKCj4j47PnDmDgRmGgkJsgtg0DwWFAN8FHNSglgPxAAAAAElFTkSuQmCC)">
                            &nbsp;
                        </v-responsive>
                        <v-responsive v-else aspect-ratio="1" :style="getRgbStyle(product)">{{ product.rgb ? '&nbsp;' : 'ND' }}</v-responsive>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text>
                <p>
                    {{ product.longDesc }} - {{ product.ral }} - {{ product.colore }}
                </p>
            </v-card-text>
            <v-card-actions class="primary mx-auto">
                <v-spacer></v-spacer>
                <v-btn flat color="white" class="px-0 py-1" >
                    <v-icon class="mr-2">mdi-eye</v-icon> {{ $t('Views.Search.product_details_link_label') }} <v-icon class="mr-2">mdi-chevron-right</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>
import {publicPath} from "../../vue.config";
export default {
    name: 'ProductListItem',
    props: ['product'],
    data() {
        return {
            publicPath: publicPath
        }
    },
    methods: {
        getRgbStyle(item) {
            if(item.productsEffect === 'MET') {
                return this.getRgbMetalStyle(item.rgb)
            } else if (item.productsEffect === 'TRAS') {
                return this.getRgbTransparentStyle(item.rgb)
            }
            return 'background-color: #' + item.rgb
        },
        getRgbMetalStyle(rgb) {
            return 'background-image: linear-gradient( -90deg, #' + rgb + ', #ffffff, #' + rgb + ')'
        },
        getRgbTransparentStyle(rgb) {
            return 'background-image: linear-gradient( to right, #' + rgb + ', #ffffff)'
        }
    }
}
</script>

<style lang="scss" scoped>

    .product-item-card {
        cursor: pointer;
    }

    .product-color-box {
        border: 1px solid black;

        .v-responsive {
             /deep/ .v-responsive__content {
                font-size: 50px;
                font-style: italic;

                align-self: center;
                justify-content: center;
                text-align: center;
            }
        }
    }
</style>

